<template>
  <b-sidebar bg-variant="white" id="fub-sidebar" no-header right shadow @hidden="show = null">
    <div class="px-3 py-2">
      <i class="fas fa-close position-absolute" v-b-toggle.fub-sidebar></i>
      <div class="p-3 mt-3">
        <img src="/img/integrations/fub-logo.png" class="w-100 mb-2 integration-logo" />
      </div>
      <b-button block class="text-fub mb-4" variant="link" @click="show = null" v-if="show != null"><i class="fas fa-angles-left"></i> Back to Menu</b-button>
      <div v-if="show == null">
        <b-list-group>
          <b-list-group-item class="text-fub" @click="goToIntegration"><i class="fas fa-network-wired"></i> Integration</b-list-group-item>
          <b-list-group-item class="text-fub" @click="show = 'people'"><i class="fas fa-users"></i> People</b-list-group-item>
          <b-list-group-item class="text-fub" @click="show = 'leads'"><i class="fas fa-filter"></i> Leads</b-list-group-item>
          <b-list-group-item class="text-fub" @click="show = 'tasks'"><i class="fas fa-list"></i> Tasks</b-list-group-item>
          <b-list-group-item class="text-fub" @click="show = 'deals'"><i class="fas fa-handshake-simple"></i> Deals</b-list-group-item>
        </b-list-group>
      </div>
      <people v-if="show == 'people'"></people>
      <leads v-if="show == 'leads'"></leads>
      <tasks v-if="show == 'tasks'"></tasks>
      <deals v-if="show == 'deals'"></deals>
    </div>
  </b-sidebar>
</template>

<script>
import People from '@/views/Components/FUB/People';
import Leads from '@/views/Components/FUB/Leads';
import Tasks from '@/views/Components/FUB/Tasks';
import Deals from '@/views/Components/FUB/Deals';

export default {
  components: {
    People,
    Leads,
    Tasks,
    Deals
  },
  props: {
    section: null
  },
  data() {
    return {
      show: null,
    }
  },
  methods: {
    goToIntegration() {
      if (this.$route.name !== 'Follow Up Boss') {
        this.$router.push({
          path: '/integrations/follow-up-boss'
        });
      }
    }
  },
  watch: {
    section(to, from) {
      this.show = to;
    }
  }
};
</script>
<style lang="scss">
#fub-sidebar {
  .text-fub {
    color: #4eaddd;
    font-size: 15px;

    &:hover {
      background-color: #fcfcfc;
      color: #39a3d9;
      cursor: pointer;
    }
  }
}
</style>